import React from "react";
import { Snackbar, Alert } from "@mui/material";

const SnackbarComponent = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}  
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}  
    >
      <Alert
        onClose={onClose}
        severity="success"  
        sx={{
          width: "100%",
          backgroundColor: "white",  
          color: "black",  
          border: "1px solid #ddd",  
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;